<template>
  <div class="liu pos-manage businesser">
    <!-- 页面头部 -->
    <mt-header fixed title="业务员详情" class="title2">
      <mt-button slot="left" icon="back" @click="onBackBtnClick">返回</mt-button>
      <mt-button slot="right" @click="onEditBtnClick">编辑</mt-button>
    </mt-header>
    <!-- 页面主体 -->
    <div class="scroll-container" :style="customScrollHeight">
      <!-- 上部账号信息 -->
      <div class="form bn-form mt-15">
        <!-- 标题 -->
        <div class="title bn-form-row row-title">
          <span>账号信息</span>
        </div>
        <!-- 账号角色 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.userRole.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ data.userRole.value }}</span>
            </div>
          </div>
        </div>
        <!-- 区域经理编号 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.userParentNo.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ data.userParentNo.value }}</span>
            </div>
          </div>
        </div>
        <!-- 业务员编号 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.userNo.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ data.userNo.value }}</span>
            </div>
          </div>
        </div>
        <!-- 业务员名 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.userName.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ data.userName.value }}</span>
            </div>
          </div>
        </div>
        <!-- 业务员手机号 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.userMobile.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ data.userMobile.value }}</span>
            </div>
          </div>
        </div>
        <!-- 入职时间 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.userDate.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ data.userDate.value }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 下部身份信息 -->
      <div class="form bn-form mt-15">
        <!-- 标题 -->
        <div class="title bn-form-row row-title">
          <span>身份信息</span>
        </div>
        <!--证件照 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>证件照</span>
            </div>
            <div class="content tar">
              <div class="id-picture">
                <div class="picture-item">
                  <div class="picture-item-img">
                    <img :src="data.idCardFront.value" alt="">
                  </div>
                  <div class="picture-item-label">
                    <span>{{ data.idCardFront.label }}</span>
                  </div>
                </div>
                <div class="picture-item">
                  <div class="picture-item-img">
                    <img :src="data.idCardBack.value" alt="">
                  </div>
                  <div class="picture-item-label">
                    <span>{{ data.idCardBack.label }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 姓名 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.idCardName.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ data.idCardName.value }}</span>
            </div>
          </div>
        </div>
        <!-- 身份证号 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.idCardNumber.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ data.idCardNumber.value }}</span>
            </div>
          </div>
        </div>
        <!-- 有效开始日期 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.idCardStartDate.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ data.idCardStartDate.value }}</span>
            </div>
          </div>
        </div>
        <!-- 有效截止日期 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.idCardEndDate.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ data.idCardEndDate.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { GetXHZSSalesmanOne } from '@/api/customer';

export default {
  name: 'BusinesserDetail',
  data() {
    return {
      data: {
        userRole: { label: '账号角色', value: '' },
        userParentNo: { label: '区域经理编号', value: '' },
        userNo: { label: '业务员编号', value: '' },
        userName: { label: '业务员名', value: '' },
        userMobile: { label: '业务员手机号', value: '' },
        userDate: { label: '入职时间', value: '' },
        idCardFront: { label: '头像面', value: '' },
        idCardBack: { label: '国徽面', value: '' },
        idCardName: { label: '姓名', value: '' },
        idCardNumber: { label: '身份证号', value: '1' },
        idCardStartDate: { label: '有效开始日期', value: '' },
        idCardEndDate: { label: '有效截止日期', value: '' },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initData();
    });
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 加载数据
      this.getXHZSSalesmanOne();
    },
    // 通过接口获取数据
    getXHZSSalesmanOne() {
      CusLoadingOpen();
      GetXHZSSalesmanOne({ salesmanId: this.$route.query.id })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.data.userRole.value = res.data.typeName;
              this.data.userParentNo.value = res.data.managerNum || '--';
              this.data.userNo.value = res.data.userNum;
              this.data.userName.value = res.data.name;
              this.data.userMobile.value = res.data.mobile;
              this.data.userDate.value = res.data.insertDate;
              this.data.idCardFront.value = res.data.idcardFrontUrl;
              this.data.idCardBack.value = res.data.idcardBackUrl;
              this.data.idCardName.value = res.data.idCardName;
              this.data.idCardNumber.value = res.data.idCardNum;
              this.data.idCardStartDate.value = res.data.idCardDate.split('-')[0];
              this.data.idCardEndDate.value = res.data.idCardDate.split('-')[1];
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 返回按钮
    onBackBtnClick() {
      this.$router.go(-1);
    },
    // 编辑按钮
    onEditBtnClick() {
      this.$router.push({ path: '/businessermanage/businesseredit', query: { id: this.$route.query.id } });
    },
  },
};
</script>>
